export class VkPixel {

    constructor(options) {
        this.options = { ...{listId: null}, ...options };
    }
    sendProductEvent(name, params) {
        try {
            if (typeof VK !== 'undefined') {
                VK.Retargeting.ProductEvent(this.options.listId, name, params);
                console.log('VkPixel: VK.Retargeting.ProductEvent("' + this.options.listId + '","' + name + '", ' + JSON.stringify(params) + ')');
            } else {
                console.log('VkPixel: VK undefined');
            }
        } catch (e) {
            console.log('VkPixel: ' + e);
        }
    }
    onLoadDetail(product) {
        if (product) {
            this.sendProductEvent('view_product', {products: [{id: product.id, price: product.price}]});
        }
    }
    onPageLoad(params) {
        const pages = ['home', 'category', 'search', 'other', 'completion'];
        let products = params.products ? params.products.map(product => {
            return {
                id: product.id,
                price: product.price
            }
        }) : [];

        if (params.page && pages.indexOf(params.page) !== -1) {
            if (params.page === 'completion') {
                this.sendProductEvent('purchase', {products: products});
            } else {
                this.sendProductEvent(`view_${params.page}`, {products: products});
            }
        }
    }
    onAddToCart(product) {
        if (product) {
            this.sendProductEvent('add_to_cart', {products: [{id: product.id, price: product.price}]});
        }
    }
    onRemoveFromCart(products) {
        if (products) {
            products = products.map(product => {
                return {
                    id: product.id,
                    price: product.price
                }
            });
            this.sendProductEvent('remove_from_cart', {products: products});
        }
    }
    onCheckout(step, products) {
        if (step && products) {
            products = products.map(product => {
                return {
                    id: product.id,
                    price: product.price
                }
            });
            if (step === 1) {
                this.sendProductEvent('init_checkout', {products: products});
            } else if (step === 5) {
                this.sendProductEvent('add_payment_info', {products: products});
            }
        }
    }
    onOneClickPurchased(params) {
        if (params) {
            let products = params.products ? params.products : [];
            this.sendProductEvent('purchase', {products: products});
        }
    }
}
